import { persistStateTypes as PERSIST_STATE_TYPES } from 'a/reducers/persistStateReducer';
import MeasureIds from 'a/placementTool/data/measureIds';
import { ACTIONS } from 'a/placementTool/data/constants';
import gameIds from 'root/activities/hub/data/GameIds';
import { REDUX_ACTIONS } from 'a/blending/constants';

const MEASURE_ID = MeasureIds.BLENDING;
const GAME_ID = gameIds.BLENDING;

/**
 * Most RWR state is handled internally for Blending, so this reducer is literally
 * just for intermediate saves and reporting final scores.
 */

export const initialState = {
  questionIndex: 0,
  responses: {},
  numberIncorrect: 0,
  questionsCorrectByItemType: {},
  hasLoaded: false,
  roundSessionData: {},
};

export default (state = initialState, { gameId, type, payload }) => {
  if (gameId !== MEASURE_ID && gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case ACTIONS.COMPLETE_EVENTS_FIRED:
      return {
        ...state,
        areCompleteEventsFired: true,
      };
    case REDUX_ACTIONS.SET_QUESTION_INDEX: {
      return {
        ...state,
        questionIndex: payload,
      };
    }
    case REDUX_ACTIONS.SET_RESPONSES: {
      return {
        ...state,
        responses: payload,
      };
    }
    case PERSIST_STATE_TYPES.REQUESTERROR_GAMESTATE:
    default:
      return state;
  }
};
